import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { ACCOUNTING_MANUAL_TRANSACTION_BASE_PATH } from '../../../../../../../../../features/accounting/transaction/accounting-transaction-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/transaction/_transaction')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'decl-transaction-list',
        label: 'Accounting',
        to: ACCOUNTING_MANUAL_TRANSACTION_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
